import { __assign } from "tslib";
import { assertNever } from '../../utils/ts-assert-never';
import { ActionTypes } from './actions';
import { Countries } from './constants';
import { getPhoneValues } from './utils';
export var reducerStateInit = function (_a) {
    var defaultCountryCode = _a.defaultCountryCode, value = _a.value, locale = _a.locale;
    var initialCountry = Countries.INT;
    var countryCodeFromLocale = locale === null || locale === void 0 ? void 0 : locale.slice(-2);
    if (defaultCountryCode && Countries[defaultCountryCode]) {
        initialCountry = Countries[defaultCountryCode];
    }
    else if (countryCodeFromLocale && Countries[countryCodeFromLocale]) {
        initialCountry = Countries[countryCodeFromLocale];
    }
    var _b = getPhoneValues(value, initialCountry), countryPhoneCode = _b.countryPhoneCode, localPhoneNumber = _b.localPhoneNumber, selectedCountry = _b.selectedCountry;
    return {
        countryPhoneCode: countryPhoneCode,
        localPhoneNumber: localPhoneNumber,
        openDropDown: false,
        focusInput: false,
        selectedCountry: selectedCountry,
    };
};
export var reducer = function (state, action) {
    switch (action.type) {
        case ActionTypes.UPDATE_VALUE:
            return __assign(__assign({}, state), { countryPhoneCode: action.countryPhoneCode, localPhoneNumber: action.localPhoneNumber, selectedCountry: action.selectedCountry });
        case ActionTypes.TOGGLE_DROPDOWN:
            return __assign(__assign({}, state), { openDropDown: action.open !== undefined ? action.open : !state.openDropDown });
        case ActionTypes.UPDATE_SELECTED_COUNTRY:
            return {
                countryPhoneCode: "+" + action.selectedCountry.countryPhoneCode,
                localPhoneNumber: '',
                selectedCountry: action.selectedCountry,
                openDropDown: false,
                focusInput: true,
            };
        case ActionTypes.ON_FOCUS_INPUT:
            var countryPhoneCode = state.countryPhoneCode, localPhoneNumber = state.localPhoneNumber;
            return __assign(__assign({}, state), { openDropDown: false, countryPhoneCode: !countryPhoneCode && !localPhoneNumber ? '+' : countryPhoneCode });
        case ActionTypes.ON_BLUR_INPUT:
            return __assign(__assign({}, state), { countryPhoneCode: '' });
        case ActionTypes.UPDATE_FOCUS_INPUT:
            return __assign(__assign({}, state), { focusInput: action.focusInput });
        default:
            assertNever(action);
    }
};
//# sourceMappingURL=reducer.js.map